/* Little Hands — Mealtime Set product page
   Gallery, colour swatches, bundle ladder, sticky bar, swipe row.
   No dependencies and no theme hooks, so it survives Broadcast updates. */
(function () {
  'use strict';

  var track = document.getElementById('track');
  var dots  = document.getElementById('dots');
  var thumbs= document.getElementById('thumbs');
  var count = document.getElementById('count');

  /* ---------- gallery ---------- */
  var slides = track ? track.querySelectorAll('.slide') : [];
  var cur = -1;

  function go(i) {
    if (!track || !slides.length) return;
    i = (i + slides.length) % slides.length;
    track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
  }
  function mark(i) {
    if (i === cur) return;
    cur = i;
    if (dots) [].forEach.call(dots.children, function (d, k) { d.classList.toggle('on', k === i); });
    if (thumbs) [].forEach.call(thumbs.children, function (t, k) { t.classList.toggle('on', k === i); });
    if (count) count.textContent = (i + 1) + ' / ' + slides.length;
  }
  if (track && slides.length) {
    for (var i = 0; i < slides.length; i++) {
      (function (n) {
        if (dots) {
          var d = document.createElement('button');
          d.type = 'button';
          d.setAttribute('aria-label', 'Photo ' + (n + 1));
          d.onclick = function () { go(n); };
          dots.appendChild(d);
        }
        if (thumbs && thumbs.children[n]) thumbs.children[n].onclick = function () { go(n); };
      })(i);
    }
    track.addEventListener('scroll', function () {
      mark(Math.round(track.scrollLeft / track.clientWidth));
    }, { passive: true });
    var prev = document.getElementById('prev'), next = document.getElementById('next');
    if (prev) prev.onclick = function () { go(cur - 1); };
    if (next) next.onclick = function () { go(cur + 1); };
    mark(0);
  }

  /* ---------- colour swatches: set the variant and show its photo ---------- */
  var swRow = document.getElementById('swRow');
  var hidden = document.getElementById('lhVariant');

  function slideIndexForMedia(id) {
    for (var k = 0; k < slides.length; k++) {
      if (slides[k].getAttribute('data-media-id') === String(id)) return k;
    }
    return -1;
  }

  if (swRow) {
    [].forEach.call(swRow.querySelectorAll('.sw'), function (btn) {
      btn.addEventListener('click', function () {
        [].forEach.call(swRow.querySelectorAll('.sw'), function (b) { b.classList.remove('on'); });
        btn.classList.add('on');

        var id = btn.getAttribute('data-variant');
        if (hidden) hidden.value = id;

        var name = btn.getAttribute('data-name');
        var price = btn.getAttribute('data-price');
        var avail = btn.getAttribute('data-available') === 'true';

        setText('swName', name);
        setText('hdPrice', price);
        setText('spPrice', price);
        setText('spName', document.querySelector('.buy h1').textContent.trim() + ' · ' + name);

        var atc = document.getElementById('atc');
        if (atc) {
          atc.disabled = !avail;
          atc.textContent = avail ? 'Add to cart – ' + price : 'Sold out';
        }

        var media = btn.getAttribute('data-media');
        if (media) {
          var idx = slideIndexForMedia(media);
          if (idx > -1) go(idx);
        }

        // keep the URL shareable
        if (window.history && history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', id);
          history.replaceState({}, '', u);
        }
      });
    });
  }

  function setText(id, v) { var el = document.getElementById(id); if (el && v) el.textContent = v; }

  /* ---------- bundle ladder ---------- */
  var offers = document.getElementById('offers');
  if (offers) {
    [].forEach.call(offers.querySelectorAll('.offer'), function (o) {
      o.addEventListener('click', function () {
        [].forEach.call(offers.querySelectorAll('.offer'), function (x) { x.classList.remove('on'); });
        o.classList.add('on');

        var mode = o.getAttribute('data-mode');
        var price = (o.querySelector('.p') || {}).textContent || '';
        price = price.replace(/\s+/g, ' ').trim().split(' ').pop();

        var form = document.getElementById('atc');
        var link = document.getElementById('atcLink');
        var sticky = document.getElementById('atc2');

        if (mode === 'link') {
          // the bundles are their own Shopify products, so send them there
          var href = o.getAttribute('data-href');
          if (form) form.hidden = true;
          if (sticky) sticky.hidden = true;
          if (link) {
            link.hidden = false;
            link.href = href;
            link.textContent = 'View this bundle – ' + price;
          }
        } else {
          if (form) form.hidden = false;
          if (sticky) sticky.hidden = false;
          if (link) link.hidden = true;
        }
        setText('spPrice', price);
      });
    });
  }

  /* ---------- swipe row (used by the "Real jobs" module) ---------- */
  var jt = document.getElementById('jobsTrack'), jb = document.getElementById('jobsBar');
  if (jt) {
    var step = function () { var c = jt.querySelector('.job'); return c ? c.offsetWidth + 14 : 300; };
    var upd = function () {
      var max = jt.scrollWidth - jt.clientWidth, vis = jt.clientWidth / jt.scrollWidth;
      if (jb) {
        jb.style.width = (vis * 100) + '%';
        jb.style.transform = 'translateX(' + ((max ? jt.scrollLeft / max : 0) * (1 / vis - 1) * 100) + '%)';
      }
    };
    jt.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
    var jp = document.getElementById('jobsPrev'), jn = document.getElementById('jobsNext');
    if (jp) jp.onclick = function () { jt.scrollBy({ left: -step(), behavior: 'smooth' }); };
    if (jn) jn.onclick = function () { jt.scrollBy({ left: step(), behavior: 'smooth' }); };
  }

  /* ---------- deep links into the accordions ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
    if (!a) return;
    var el = document.getElementById(a.getAttribute('href').slice(1));
    if (el && el.tagName === 'DETAILS') el.open = true;
  });
})();
